import { LEGAL_CONTACT, LEGAL_UPDATED_AT } from "./legal-config";
import LegalPageLayout, { LegalSection } from "./LegalPageLayout";

export default function MentionsLegales() {
  return (
    <LegalPageLayout
      title="Mentions légales"
      lead="Les informations qui permettent d’identifier l’éditeur de Harmonauria, ses prestataires techniques et les règles qui encadrent les contenus du refuge."
      updatedAt={LEGAL_UPDATED_AT}
    >
      <LegalSection
        number="01"
        title="Éditeur de Harmonauria"
      >
        <dl className="legal-data-list">
          <dt>Éditeur</dt>
          <dd>{LEGAL_CONTACT.publisherName}</dd>
          <dt>Statut</dt>
          <dd>{LEGAL_CONTACT.status}</dd>
          <dt>SIREN</dt>
          <dd>{LEGAL_CONTACT.siren}</dd>
<dt>SIRET</dt>
<dd>{LEGAL_CONTACT.siret}</dd>
<dt>Adresse électronique</dt>
<dd>
  <a href={`mailto:${LEGAL_CONTACT.email}`}>{LEGAL_CONTACT.email}</a>
</dd>
        </dl>
      </LegalSection>

      <LegalSection
        number="02"
        title="Direction de la publication"
      >
        <p>Le directeur de la publication est {LEGAL_CONTACT.publisherName}.</p>
      </LegalSection>

      <LegalSection
        number="03"
        title="Hébergement et infrastructure"
      >
        <p>Harmonauria est hébergé au moyen des services Firebase de Google.</p>
        <dl className="legal-data-list">
          <dt>Prestataire</dt>
          <dd>Google Ireland Limited</dd>
          <dt>Adresse</dt>
          <dd>Gordon House, Barrow Street, Dublin 4, Irlande</dd>
          <dt>Téléphone</dt>
          <dd>+353 1 533 9837</dd>
          <dt>Nom de domaine</dt>
          <dd>harmonauria.fr, géré au moyen des services OVHcloud</dd>
        </dl>
      </LegalSection>

      <LegalSection
        number="04"
        title="Paiements"
      >
        <p>Les paiements et la gestion des abonnements au Refuge Personnel sont traités par Stripe. Harmonauria ne conserve pas les numéros complets de carte bancaire.</p>
        <dl className="legal-data-list">
          <dt>Prestataire</dt>
          <dd>Stripe Payments Europe, Limited</dd>
          <dt>Adresse</dt>
          <dd>1 Grand Canal Street Lower, Grand Canal Dock, Dublin, D02 H210, Irlande</dd>
        </dl>
      </LegalSection>

      <LegalSection
        number="05"
        title="Propriété intellectuelle"
        highlight
      >
        <p>Les musiques, paysages sonores, respirations guidées, textes, illustrations, éléments graphiques, vidéos, marques, logos et interfaces présents sur Harmonauria sont protégés par le droit de la propriété intellectuelle.</p>
        <p>Les compositions musicales sont créées par un humain et ne sont pas générées par intelligence artificielle. Sauf mention contraire, les contenus originaux restent la propriété exclusive de {LEGAL_CONTACT.publisherName}.</p>
        <p>Toute reproduction, représentation, adaptation, extraction, diffusion ou exploitation commerciale, totale ou partielle, sans autorisation écrite préalable est interdite.</p>
      </LegalSection>

      <LegalSection
        number="06"
        title="Contact"
      >
        <p>Pour toute question relative à Harmonauria ou à ces mentions légales, écrivez à <a href={`mailto:${LEGAL_CONTACT.email}`}>{LEGAL_CONTACT.email}</a>.</p>
      </LegalSection>
    </LegalPageLayout>
  );
}
